import VideoContentLoading from "./VideoContentLoading";

type Props = {
  videoUrl: string;
  title: string;
  isLoading?: boolean;
};

export default function VideoContent({ videoUrl, title, isLoading }: Props) {
  if (isLoading) {
    return <VideoContentLoading />;
  }

  const getYouTubeEmbedUrl = (url: string) => {
    try {
      let videoId = "";
      if (url.includes("youtube.com/watch")) {
        const urlParams = new URLSearchParams(new URL(url).search);
        videoId = urlParams.get("v") || "";
      } else if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1]?.split("?")[0] || "";
      } else if (url.includes("youtube.com/embed/")) {
        return url; // Already an embed URL
      }

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
      return url; // Return original if not recognized/convertible
    } catch (e) {
      return url;
    }
  };

  const embedUrl = getYouTubeEmbedUrl(videoUrl);

  return (
    <section>
      <h3 className="text-theme-slate-700 text-2xl font-semibold leading-6 mb-6">
        {title}
      </h3>
      <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
        <iframe
          src={embedUrl}
          title={title}
          className="absolute top-0 left-0 w-full h-full rounded-lg"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </section>
  );
}
